import React, { useEffect, useRef } from 'react';

interface Props {
  html: string;
}

const TemplatePreview: React.FC<Props> = ({ html }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      // Write the HTML directly to the iframe
      const doc = iframeRef.current.contentDocument;
      if (doc) {
        doc.open();
        doc.write(html);
        doc.close();
      }
    }
  }, [html]);

  return (
    <div className="relative bg-gray-100 overflow-hidden shadow-inner">
      <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]" />
      <div className="relative">
        <iframe
          ref={iframeRef}
          title="Template Preview"
          className="w-full bg-white"
          style={{
            transform: 'scale(1)',
            transformOrigin: 'top left',
            width: '100%',
            height: '625px'
          }}
        />
      </div>
    </div>
  );
};

export default TemplatePreview;